<template>
  <div class="wrapper">
    <div class="page-title">合同管理</div>

    <div class="padding-sm flex align-center justify-around">
      <router-link :to="'/home/list?id='+$route.query.id+'&cid='+list[0].id+'&name='+ list[0].label" class="contract-link">
        <i class="el-icon-document-copy"></i>
        <p>合同素材</p>
      </router-link>
      <router-link :to="'/home/contractList?id='+$route.query.id+'&cid='+list[1].id+'&name='+ list[1].label" class="contract-link">
        <i class="el-icon-document"></i>
        <p>我的合同</p>
      </router-link>
      <router-link :to="'/home/contractStatistics?id='+$route.query.id+'&cid='+list[2].id+'&name='+ list[2].label" class="contract-link">
        <i class="el-icon-data-line"></i>
        <p>合同统计</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "contract",
  data() {
    return {
      list:[]
    }
  },
  created() {
    this.GetFolderList()
  },
  components: {},
  methods: {
    GetFolderList() {
      this.$api.apiContent.GetFolderList({
        mid: this.$store.state.userMid,
        team: 4,
        kid: this.$route.query.id
      }).then(res => {
        this.list = res.data
      }).catch()
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.wrapper {
  .page-title{
    height: 80px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 20px;
    font-size: 18px;
  }
  .contract-link{
    display: block;
    width: 30%;
    border: 1px solid #0a2240;
    border-radius: 10px;
    padding: 30px;
    &:hover{
      background: #0a2240;
      i{
        color: #fff;
      }
      p{
        color: #fff;
      }
    }
    i{
      display: block;
      margin: 0 auto 30px;
      font-size: 48px;
      text-align: center;
      color: #0a2240;
    }
    p{
      text-align: center;
      font-size: 16px;
      color: #0a2240;
    }
  }
}
</style>
